import React, { useState, useEffect } from 'react'
import { getAppliedcoutnRefrenceByDate } from '../ActionCreator'
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import moment from 'moment';
import TuneIcon from '@mui/icons-material/Tune';

export default function AppliedLeadList({ Data }) {
      const [loader, setLoader] = useState(false);
      const [appliedLeads, setAppliedLeads] = useState('');
    const [payload, setPayload] = useState({
        filter: "Daily",
        fromDate: moment(new Date()).format("YYYY-MM-DD"),
        toDate: moment(new Date()).format("YYYY-MM-DD"),
    })

    useEffect(() => {
        applyFilter()
    }, [])

    const handleChange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const applyFilter = () => {
getAppliedcoutnRefrenceByDateFn()
    }

    const getAppliedcoutnRefrenceByDateFn = () => {
        setLoader(true)
        const start = moment(payload?.fromDate)?.format("DD-MM-YYYY")
        const end = moment(payload?.toDate)?.format("DD-MM-YYYY")
        getAppliedcoutnRefrenceByDate(start, end, Data?.referenceCode, Callback => {
            setLoader(false)
            setAppliedLeads(Callback)
        })
    }

    return (
        <>
        {
            loader ? <Loader />:""
        }
            <div className="container-fluid marketing-main-css" style={{ marginTop: '20px' }}>
                <div className="row">
                    <div className="col-sm-2 col-xs-12">
                        <TuneIcon />
                        <span className="ms-3 filterHeaders">Filter</span>
                        <select
                            name=""
                            id=""
                            value={payload.filter}
                            className="form-select"
                            onChange={(e) => handleChange(e, "filter")}
                            style={{ width: '100%', padding: '10px', color: '#000' }}
                        >
                            <option value="daily">Daily</option>
                        </select>
                    </div>

                    <div className="col-sm-2 col-xs-12">
                        From
                        <input
                            type="date"
                            id="startDate"
                            placeholder="DD/MM/YY"
                            name="fromDate"
                            value={payload.fromDate}
                            onChange={(e) => handleChange(e, "fromDate")}
                            className=" form-control"
                            style={{
                                border: "1px solid gray",
                                borderRadius: "6px",
                                padding: "10px",
                            }}
                        />

                    </div>


                    <div className="col-sm-2 col-xs-12">
                        <div className="filterHeaders" style={{ marginTop: '4px' }}>to</div>
                        <input
                            type="date"
                            id="endDate"
                            name="toDate"
                            value={payload.toDate}
                            onChange={(e) => handleChange(e, "toDate")}
                            placeholder="DD/MM/YY"
                            className=" form-control"
                            style={{
                                border: "1px solid gray",
                                borderRadius: "6px",
                                padding: "10px",
                            }}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button
                            className="btn btn-primary mt-4 "
                            style={{
                                marginTop: '27px',
                                padding: '9px',
                                borderRadius: '5px'
                            }}
                            onClick={() => applyFilter()}
                        >
                            Apply Filter
                        </button>
                    </div>

                </div>

                <hr />
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-xs-12">
                        <div className='credit-table'>
                            <table>
                                <thead style={{ background: '#b9d8f9', color: '#000' }}>
                                    <tr className="thead-class">
                                        <th className="">Loan Status</th>
                                        <th className="">Lead Counts</th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    {console.log('appliedLeads', appliedLeads)}
                                    {appliedLeads !== '' &&
                                        appliedLeads.map((item) => {
                                            return (
                                                <tr style={{ borderBottom: "none" }} onClick={() => {
                                                    handleRefr("td", item);
                                                }}>
                                                    <td
                                                        scope="col"

                                                    >
                                                        <span id="comment">
                                                            <b>{item.loan_status}</b>
                                                        </span>
                                                    </td>
                                                    <td
                                                        scope="col"

                                                    >
                                                        <span id="comment">
                                                            <b>{item.count}</b>
                                                        </span>
                                                    </td>
                                                   
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
